import React from "react";
import { Icon, IconButton, Tooltip, useColorMode, useColorModeValue } from "@chakra-ui/react";
import { MdDarkMode, MdLightMode } from "react-icons/md";

// Cambia entre modo claro y modo noche. Chakra lo recuerda en este navegador.
export default function BotonModoNoche() {
  const { colorMode, toggleColorMode } = useColorMode();
  const navbarIcon = useColorModeValue("gray.500", "white");
  const fondoHover = useColorModeValue("gray.100", "whiteAlpha.200");
  const oscuro = colorMode === "dark";
  const etiqueta = oscuro ? "Modo claro" : "Modo noche";

  return (
    <Tooltip label={etiqueta} hasArrow openDelay={400}>
      <IconButton
        aria-label={etiqueta}
        icon={<Icon as={oscuro ? MdLightMode : MdDarkMode} boxSize={{ base: "20px", md: "22px" }} />}
        variant="ghost"
        borderRadius="full"
        w={{ base: "38px", md: "42px" }}
        h={{ base: "38px", md: "42px" }}
        minW="auto"
        color={navbarIcon}
        _hover={{ bg: fondoHover }}
        onClick={toggleColorMode}
      />
    </Tooltip>
  );
}
